import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Section from '../../components/Sections/Section';
import Stepper from '../../components/Stepper/Stepper.js';
import ContactCard from '../../components/Cards//ContactCard/ContactCard';
import FormSection from '../../components/Sections/FormSection/FormSection.js';
import { animateContactCards } from './AboutAnimations.js';
import { animateH2Elements } from '../Home/HomeAnimations.js';
import Button from '../../components/Button/Button';

import janwillem2024 from '../../assets/janwillem-2024.jpeg';
import nigel2024 from '../../assets/nigel-2024.jpeg';
import siebe2024 from '../../assets/siebe-2024.jpeg';
import titus2024 from '../../assets/titus-2024.jpeg';

import './About.css';

const About = () => {
    const profilesWrapperRef = useRef(null);
    const h1Ref = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (profilesWrapperRef.current) {
            animateContactCards(profilesWrapperRef);
        }
    }, []);

    const animateH1 = useCallback((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                animateH2Elements([entry.target]);
                observer.unobserve(entry.target);
            }
        });
    }, []);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1,
        };

        const observer = new IntersectionObserver(animateH1, options);

        if (h1Ref.current) {
            observer.observe(h1Ref.current);
        }

        return () => {
            if (h1Ref.current) {
                observer.unobserve(h1Ref.current);
            }
            observer.disconnect();
        };
    }, [animateH1]);

    const handleContactClick = (e) => {
        e.preventDefault();
        if (location.pathname === '/') {
          const formSection = document.getElementById('form-section');
          if (formSection) {
            formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        } else {
          navigate('/', { state: { scrollToForm: true } });
        }
    };

    const steps = [
        { title: 'Hoge kwaliteit'},
        { title: 'Proffesionele aanpak'},
        { title: 'Duurzame partnerships'},
    ];

    const contact1 = {
        imageLink: titus2024,
        headerTag: "Titus",
        description: "Co-founder",
        about: "AI development",
        linkButton: `mailto:${'titus'}@flintandsteel.io?subject=Hey, Titus!`,
    };

    const contact2 = {
        imageLink: janwillem2024,
        headerTag: "Jan-Willem",
        description: "Co-founder",
        about: "CEO",
        linkButton: `mailto:${'janwillem'}@flintandsteel.io?subject=Hey, Jan-Willem!`,
    };

    const contact3 = {
        imageLink: nigel2024,
        headerTag: "Nigel",
        description: "Co-founder",
        about: "Product development",
        linkButton: `mailto:${'nigel'}@flintandsteel.io?subject=Hey, Nigel!`,
    };

    const contact4 = {
        imageLink: siebe2024,
        headerTag: "Siebe",
        description: "Co-founder",
        about: "Business",
        linkButton: `mailto:${'siebe'}@flintandsteel.io?subject=Hey, Siebe!`,
    };

    return (
        <div className="about-page">
            <Section>
                <div className="about-intro-wrapper">
                    <h1 className="about-h1" ref={h1Ref}>Onze passie voor techniek komt hier écht tot leven.</h1>
                    <p className="label">Wij zijn FlintandSteel, een collectief van vrienden met breed inzetbare kennis op basis van onze ervaringen in technologie. Met diverse ervaring in- en rondom systemen en gebruik van technologie in het dagelijkse leven helpen wij jou graag om jouw idee een werkelijkheid te maken.</p>
                    <Button variant="outlined" onClick={handleContactClick}>Stuur ons een berichtje</Button>
                </div>
            </Section>
            <Section>
                <div className="profiles-wrapper" ref={profilesWrapperRef}>
                    <div className="grid grid--4">
                        {contact1 && (
                            <ContactCard {...contact1}>
                                <p>{contact1.description}</p>
                                <a href={contact1.linkButton} target="_blank" rel="noopener noreferrer">Mail</a>
                            </ContactCard>
                        )}
                        {contact2 && (
                            <ContactCard {...contact2}>
                                <p>{contact2.description}</p>
                                <a href={contact2.linkButton} target="_blank" rel="noopener noreferrer">Mail</a>
                            </ContactCard>
                        )}
                        {contact3 && (
                            <ContactCard {...contact3}>
                                <p>{contact3.description}</p>
                                <a href={contact3.linkButton} target="_blank" rel="noopener noreferrer">Mail</a>
                            </ContactCard>
                        )}
                        {contact4 && (
                            <ContactCard {...contact4}>
                                <p>{contact4.description}</p>
                                <a href={contact4.linkButton} target="_blank" rel="noopener noreferrer">Mail</a>
                            </ContactCard>
                        )}
                    </div>
                </div>
            </Section>
            <Section>
                <div className="sub-label">
                    <p className="label">Wij staan garant voor:</p>
                </div>
                <Stepper>
                    {steps.map((step, index) => (
                        <Stepper.Item
                            key={index}
                            title={step.title}
                            description={step.description}
                        />
                    ))}
                </Stepper>
            </Section>
            <FormSection></FormSection>
        </div>
    );
};

export default About;